module.exports = __webpack_public_path__ + "img/back_image.d62f2f6c.png";